import React, { FC, useId } from 'react';
import { useField } from 'formik';

import { IFormFieldProps } from '@components/Form/types';
import { Status } from '@components/Status';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { Field } from '../Field';
import { Input } from '../Input';

export const InputGroupField: FC<IFormFieldProps> = (props) => {
  const { dictionary } = useLanguageContext();

  const {
    id = '',
    showLabel = true,
    label = '',
    showHint = true,
    hint = '',
    status,
    isVerified,
    showRequired = false,
    required = true,
    fieldControls,
    fieldBtn,
  } = props;

  const uniqId = useId();

  const fieldId = id || uniqId;

  const [field, meta] = useField(props);

  const statusLabel = isVerified ? dictionary.statuses.connected : dictionary.statuses.notConnected;

  const statusVariant = isVerified ? 'success' : 'warning';

  return (
    <Field
      id={fieldId}
      showLabel={showLabel}
      label={label}
      showError={meta.touched}
      error={meta.error}
      showHint={showHint}
      hint={hint}
      showRequired={showRequired}
      isRequired={required}
      fieldControls={fieldControls}
      status={status && <Status text={statusLabel} variant={statusVariant} />}
    >
      <div className="form-group">
        <div className="form-group-item">
          <div className="field-control">
            <Input {...field} {...props} hasError={meta.touched && !!meta.error} />
          </div>
        </div>
        {fieldBtn && <div className="form-group-item">{fieldBtn}</div>}
      </div>
    </Field>
  );
};
